var map = {
	"./Google-Classroom.svg": 87411,
	"./Publish.svg": 37877,
	"./Select_arrow2.svg": 62512,
	"./add-to-folder.svg": 68598,
	"./assessment_blue_icon.svg": 6515,
	"./assessment_white_icon.svg": 64820,
	"./assessments.svg": 28645,
	"./assigning.svg": 55673,
	"./assigningstudent.svg": 66710,
	"./browsingassessments.svg": 7072,
	"./creatinggroups.svg": 23809,
	"./delete.svg": 15581,
	"./digitallibrary.svg": 54533,
	"./folder-big.svg": 28749,
	"./folder_blue_icon.svg": 74873,
	"./folder_white_icon.svg": 83134,
	"./home_blue_icon.svg": 88432,
	"./home_browse_gray.svg": 50800,
	"./home_white_icon.svg": 24869,
	"./icon-add-circle-solid.svg": 49588,
	"./icon-add-cricle-outline.svg": 11909,
	"./icon-add-folder.svg": 99286,
	"./icon-add-note-circle-outline.svg": 51026,
	"./icon-add-note.svg": 53338,
	"./icon-add-person.svg": 64077,
	"./icon-add-to-library-white.svg": 86939,
	"./icon-add-to-library.svg": 79627,
	"./icon-add-user-circle-outline.svg": 91861,
	"./icon-add-user-circle-solid.svg": 76394,
	"./icon-add-user.svg": 88143,
	"./icon-add.svg": 63241,
	"./icon-arrow-left.svg": 51951,
	"./icon-arrow-right.svg": 7498,
	"./icon-books.svg": 18806,
	"./icon-browse-circle-solid.svg": 20905,
	"./icon-browse.svg": 54798,
	"./icon-cal-circle-solid.svg": 49783,
	"./icon-cal-date.svg": 68941,
	"./icon-cal.svg": 98084,
	"./icon-check.svg": 25664,
	"./icon-chevron-down.svg": 58534,
	"./icon-chevron-left.svg": 58125,
	"./icon-chevron-right.svg": 79056,
	"./icon-chevron-up.svg": 24477,
	"./icon-clock.svg": 28522,
	"./icon-close-black.svg": 4086,
	"./icon-dark-x.svg": 47875,
	"./icon-documents.svg": 48770,
	"./icon-download.svg": 98216,
	"./icon-elearning-circle-solid.svg": 39514,
	"./icon-filter-circle-outline.svg": 40518,
	"./icon-filter-dropdown.svg": 52984,
	"./icon-folder-common.svg": 64766,
	"./icon-group-circle-solid.svg": 66468,
	"./icon-group.svg": 2201,
	"./icon-heart.svg": 35444,
	"./icon-help-circle-outline.svg": 57911,
	"./icon-info-circle-outline.svg": 68132,
	"./icon-key.svg": 81333,
	"./icon-library.svg": 75665,
	"./icon-link-circle-solid.svg": 34267,
	"./icon-list-bullet.svg": 48797,
	"./icon-list.svg": 76384,
	"./icon-mail-solid.svg": 2275,
	"./icon-more-circle-outline.svg": 86641,
	"./icon-more-circle-solid.svg": 70142,
	"./icon-more.svg": 25699,
	"./icon-notification-circle-outline.svg": 24059,
	"./icon-notification.svg": 56245,
	"./icon-pen-circle-outline.svg": 54103,
	"./icon-pencil.svg": 76119,
	"./icon-photo-circle-outline.svg": 64876,
	"./icon-photo.svg": 85660,
	"./icon-play-optimized.svg": 98058,
	"./icon-print-circle-solid.svg": 48520,
	"./icon-print.svg": 37021,
	"./icon-reader-circle.svg": 63606,
	"./icon-reader-invert.svg": 28006,
	"./icon-reader.svg": 24729,
	"./icon-schoolwide.svg": 55529,
	"./icon-search-circle-outline.svg": 82436,
	"./icon-search.svg": 85892,
	"./icon-share.svg": 39425,
	"./icon-trash-circle-outline.svg": 61102,
	"./icon-trash.svg": 50270,
	"./icon-unit-circle-solid.svg": 16589,
	"./icon-user.svg": 76665,
	"./icon-view.svg": 69267,
	"./intro.svg": 61234,
	"./introductionicon.svg": 31627,
	"./lessons_blue_icon.svg": 18570,
	"./lessons_gray.svg": 92579,
	"./lessons_white_icon.svg": 36643,
	"./library_blue_icon.svg": 66404,
	"./library_white_icon.svg": 13745,
	"./link.svg": 21108,
	"./logout_icon.svg": 21482,
	"./my-check-image.svg": 51277,
	"./navigatingunitsofstudy.svg": 88909,
	"./pdf.svg": 98118,
	"./projecticon.svg": 75844,
	"./resources_blue_icon.svg": 36602,
	"./resources_white_icon.svg": 88531,
	"./shared_folder.svg": 62398,
	"./student.svg": 49005,
	"./studentfacingside.svg": 99910,
	"./teachingresources.svg": 83392,
	"./texts_blue_icon.svg": 28169,
	"./texts_white_icon.svg": 47502,
	"./tour-assign.svg": 59856,
	"./tour-browse.svg": 12337,
	"./tour-highlighting.svg": 44703,
	"./tour-library.svg": 95140,
	"./tour-student.svg": 89932,
	"./tour-units.svg": 69728,
	"./units_blue_icon.svg": 69992,
	"./units_white_icon.svg": 51805,
	"./unitsofstudy.svg": 41321,
	"./videoicon.svg": 48042
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21372;